module.exports = __webpack_public_path__ + "img/26.99e70f7f.png";